module.exports = __webpack_public_path__ + "assets/images/cosmote_4.247c9e47189de164c6bf6b42e0b440cd.png";